import { render, staticRenderFns } from "./GuideWindow.vue?vue&type=template&id=bdbb14ee&"
import script from "./GuideWindow.vue?vue&type=script&lang=js&"
export * from "./GuideWindow.vue?vue&type=script&lang=js&"
import style0 from "./GuideWindow.vue?vue&type=style&index=0&id=bdbb14ee&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports